import { put, call, select } from 'redux-saga/effects';
import { Action } from 'typescript-fsa';
import { pushCartEditAction, PushCartEditParam } from '@app/react/action/pushCartEditAction';
import { api } from '@app/react/common/api';
import type { DesignSet } from '@app/react/const/type';
import type { ApiResponse } from '@app/react/api';
import type { AppState } from '@app/react/reducer';
import { conv, PostSelectedItems } from '@app/react/saga/conv';
import { safe } from '@app/react/saga/common/safe';
import { getCsrfToken } from '@app/react/common/getCsrfToken';

const pushCartAPI = (
    csrf: string,
    cartId: number,
    parts: PostSelectedItems,
): Promise<void> => (
    api.orderMadeFunctionEditCartPost({
        eCCUBECSRFTOKEN: csrf,
        inlineObject: {
            cartitemId: cartId,
            selectedItems: parts,
        },
    })
);

export function* pushEditCartSaga(action: Action<PushCartEditParam>): Generator {
    const customData: DesignSet = yield select((state: AppState) => state.customize);
    const selectedItems = conv(customData);
    const csrf = getCsrfToken();

    type RT = { result: ApiResponse<void>, error: Response };
    const { result, error }: RT = yield safe(
        call(pushCartAPI, csrf, customData.id, selectedItems),
    );

    if (error !== null) {
        console.error('[saga] pushEditCartSaga error:', error);
        yield put(
            pushCartEditAction.failed({
                params: action.payload,
                error: {
                    status: error.status,
                    statusText: error.statusText,
                },
            }),
        );
        return;
    }

    yield put(
        pushCartEditAction.done({
            params: action.payload,
            result,
        }),
    );
}
